import React from 'react';
import { Check, Languages, Globe, Info } from 'lucide-react';

const TranslationWizard = ({ data, setData }) => {
  const options = [
    { id: 'comments', label: 'TRADUCIR COMENTARIOS DE CÓDIGO' },
    { id: 'textElements', label: 'TRADUCIR ELEMENTOS DE TEXTO (UI)' },
    { id: 'documentation', label: 'TRADUCIR DOCUMENTACIÓN TÉCNICA' },
    { id: 'preserveSyntax', label: 'PRESERVAR SINTAXIS LÓGICA (STRICT)' }
  ];

  return (
    <div className="animate-in fade-in slide-in-from-top-4 duration-500 text-left">
      
      {/* BANNER DE GUÍA TÉCNICA (ESTILO GLOBALIZATION EXPERT) */}
      <div className="bg-blue-900/10 border-l-4 border-blue-600 p-4 mb-8 rounded-r-xl">
        <p className="text-[11px] text-blue-700 font-black uppercase tracking-widest mb-1 italic">Nota del Arquitecto:</p>
        <p className="text-[11px] text-slate-600 font-white uppercase leading-relaxed font-medium">
          Esta herramienta actúa como un **SAP Globalization & Localization Expert**. 
          Traduce comentarios, etiquetas de usuario y manuales técnicos manteniendo la integridad 
          de la sintaxis ABAP. Ideal para Roll-outs internacionales o limpieza de código Legacy, 
          garantizando que la lógica de negocio no se vea afectada por la traducción.
        </p>
      </div>
      {/* FORMULARIO DEL WIZARD */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 bg-white p-6 rounded-[24px] border border-slate-100 shadow-inner text-left">
        <div className="space-y-4 text-left">
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="text-[10px] font-black text-indigo-600 uppercase tracking-widest mb-1 block italic">Origen</label>
              <select 
                className="w-full p-3 bg-slate-50 border border-slate-200 rounded-xl text-sm outline-none focus:border-indigo-500 transition-all cursor-pointer"
                value={data.transSource || 'ES'}
                onChange={(e) => setData({...data, transSource: e.target.value})}
              >
                <option value="ES">Español</option>
                <option value="EN">Inglés</option>
                <option value="DE">Alemán</option>
                <option value="PT">Portugués</option>
              </select>
            </div>
            <div>
              <label className="text-[10px] font-black text-indigo-600 uppercase tracking-widest mb-1 block italic">Destino</label>
              <select 
                className="w-full p-3 bg-slate-50 border border-slate-200 rounded-xl text-sm outline-none focus:border-indigo-500 transition-all cursor-pointer"
                value={data.transTarget || 'EN'}
                onChange={(e) => setData({...data, transTarget: e.target.value})}
              >
                <option value="EN">Inglés</option>
                <option value="ES">Español</option>
                <option value="DE">Alemán</option>
                <option value="PT">Portugués</option>
              </select>
            </div>
          </div>
          <div>
            <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest mb-1 block italic">Contexto del Objeto</label>
            <input 
              type="text" 
              className="w-full p-3 bg-slate-50 border border-slate-200 rounded-xl text-sm outline-none focus:border-indigo-500 transition-all shadow-sm font-mono" 
              placeholder="Ej: Reporte de Ventas, Clase de Integración..." 
              value={data.transContext || ''} 
              onChange={(e) => setData({...data, transContext: e.target.value})} 
            />
          </div>
        </div>

        <div className="space-y-2 text-left">
          <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest mb-1 block italic">Alcance de la Traducción</label>
          <div className="grid grid-cols-1 gap-2">
            {options.map((opt) => (
              <button 
                key={opt.id} 
                onClick={() => setData({
                  ...data, 
                  transOptions: { ...data.transOptions, [opt.id]: !data.transOptions?.[opt.id] }
                })}
                className={`flex justify-between items-center p-2.5 px-4 rounded-xl border transition-all text-[9px] font-black tracking-widest uppercase ${data.transOptions?.[opt.id] ? 'bg-indigo-600 border-indigo-600 text-white shadow-md shadow-indigo-200' : 'bg-white border-slate-200 text-slate-400 hover:border-indigo-200'}`}
              >
                {opt.label} 
                {data.transOptions?.[opt.id] && <Check size={12} />}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TranslationWizard;